import Vue from 'vue'
import Router from 'vue-router'
import routerObj from './constants/basicRouterObject'
import _ from 'lodash'

// import HelpSample from './views/HelpSample'
// import Axios from 'axios'

Vue.use(Router)

export const createRouter = async () => {
  const newRouterObject = _.cloneDeep(routerObj)
  // Logic allowing to set the help page relatively in the application, remove in the future if unused
  // const res = await Axios.get(`${process.env.VUE_APP_API_BASE_URL}/help-url`)
  // const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
  // if (res.data.url && !regex.test(res.data.url)) {
  //   newRouterObject.routes.find(el => el.path === '/').children.push({
  //     path: res.data.url,
  //     name: 'help',
  //     component: HelpSample
  //   })
  // }
  return new Router(newRouterObject)
}
